import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import GeneralInfo from 'components/FlightEditGeneralInfo';
import PriceHistory from 'components/FlightEditPriceHistory';
import Pagination from 'components/Pagination';

import { FlightEdit_flight$key } from '__generated__/FlightEdit_flight.graphql';

type Props = {
  flight: FlightEdit_flight$key;
};

const FlightEdit: FC<Props> = props => {
  const flight = useFragment(
    graphql`
      fragment FlightEdit_flight on Flight {
        ...FlightEditGeneralInfo_flight
        ...FlightEditPriceHistory_flight
      }
    `,
    props.flight
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          hash: 'general',
          component: <GeneralInfo flight={flight} />,
        },
        {
          title: 'Kainos istorija',
          hash: 'price-history',
          component: (
            <Pagination navigate={false}>
              <PriceHistory flight={flight} />
            </Pagination>
          ),
        },
      ]}
    />
  );
};

export default FlightEdit;
